import { userEndPoints, videoNotesEndpoints } from "../config";
import CommonService from "./CommonService";

class bookService {
  async createUserNewBook(data) {
    return CommonService.post(userEndPoints.createNewBook, {
      name: data,
    });
  }

  async myAllBookList() {
    return CommonService.get(userEndPoints.myBookList);
  }

  async addNewChapter(id, chapterName) {
    return CommonService.post(userEndPoints.createChapter + `/${id}`, {
      name: chapterName,
    });
  }

  async addNewChapterData(id, data) {
    let text =
      (data?.question
        ? `<p style="margin: 10px 0 10px 0"><b>Question: ${data.question}</b></p>` +
          "\n\n"
        : "") +
        (data?.answer ? `Answer: ${data.answer}` + "\n\n" : "") +
        (data?.text ? data?.text + "\n\n" : "") || "";

    return CommonService.post(userEndPoints.createChapterData + `${id}`, {
      // question: data?.question,
      // answer: data?.answer.replace(/Alpha Bot:\s*/g, ""),
      // type: answerType,
      text: text,
      // image: data?.image,
    });
  }
  async addNewChapterDirect(id, data) {
    return CommonService.post(userEndPoints.createChapterData + `${id}`, {
      // question: data?.question,
      // answer: data?.answer.replace(/Alpha Bot:\s*/g, ""),
      // type: answerType,
      text: data,
      // image: data?.image,
    });
  }

  async updateChapterData(data, answerText, extraData) {
    console.log("answerText", answerText);
    console.log("extraData", extraData);
    return CommonService.put(userEndPoints.updateChapterData + `${data?._id}`, {
      question: data?.question,
      answer: answerText.replace(/Alpha Bot:\s*/g, ""),
      type: data?.type,
      text: extraData,
      image: data?.image,
    });
  }

  async myAllChapterbyBookid(id) {
    return CommonService.get(userEndPoints.getChapterByBookId + `/${id}`);
  }

  async chapterDetailByChapterId(id) {
    return CommonService.get(userEndPoints.chapterDetail + `/${id}`);
  }

  async getVideoSearch(search) {
    return CommonService.get(userEndPoints.searchVideo + search);
  }

  // CRETAE / UPDATE VIDEO NOTE
  async createUpdateVideoNote(data) {
    return CommonService.post(videoNotesEndpoints.createUpdateVideoNote, {
      title: data.title || "",
      link: data.link || "",
      noteTime: data.noteTime ? JSON.stringify(data.noteTime) : "[]",
    });
  }

  // CRETAE / UPDATE VIDEO NOTE
  async updateVideoNoteById(id, data) {
    return CommonService.put(videoNotesEndpoints.updateVideoNoteById+"/"+id, {
      title: data.title || "",
      link: data.link || "",
      noteTime: data.noteTime ? JSON.stringify(data.noteTime) : "[]",
    });
  }

  // GET VIDEO NOTE BY ID
  async getVideoNote(videoNoteId) {
    return CommonService.get(videoNotesEndpoints.getVideoNote + `/${videoNoteId}`);
  }
}
export default new bookService();
